import { Document, Packer, Paragraph, TextRun } from "docx";
import downloadFile from "./downloadFile";

interface IDownloadDocxFile {
	data: string;
	filename?: string | null;
}

const downloadDocxFile = ({ data, filename }: IDownloadDocxFile) => {
	const paragraphs = data.split(/\r?\n/);
	const defaultFilename = paragraphs[0]?.split(" ").slice(0, 9).join(" ") || "document";

	const doc = new Document({
		sections: [
			{
				children: paragraphs.map(
					(el) =>
						new Paragraph({
							children: [
								new TextRun({
									text: el,
									font: "Calibri",
								}),
							],
						})
				),
			},
		],
	});

	Packer.toBlob(doc).then((blob) => {
		downloadFile(blob, `${filename || defaultFilename}.docx`);
	});
};

export default downloadDocxFile;
